document.addEventListener('DOMContentLoaded', function () {
    // Make sure we're on the right page
    if (!document.querySelector('[name=Alumni4-introduction]')) {
        return;
    }

    var stillServingNotice = document.getElementById('actively-serving-notice'),
        navNext = document.getElementById('nav-next')
        revisedEndMonthInput = document.getElementById('RevisedEndMonth'),
        revisedEndYearInput = document.getElementById('RevisedEndYear'),
        outOfWindowNotice = document.getElementById('out-of-window-notice'),
        restOfIntroElement = document.getElementById('rest-of-intro-page'),
        contactInfoGroup = document.getElementById('contract-info-group'),
        navNextButton = document.getElementById('nav-next');

    function setNavButtonLabel(label) {
        navNext.innerHTML = label;
    }

    function toggleNavButtonText() {
        var navButtonText = 'Next';
        if(isStillServing() || outOfWindow()) {
            navButtonText = 'Finish';
        }
        setNavButtonLabel(navButtonText);
    }

    function isStillServing()
    {
        return getRadioValue('EndedContract') == 0 && getRadioValue('StillServingContract') == 1;
    }

    function toggleStillServingNotice() {
        navNextButton.classList.remove('hidden');
        if (isStillServing() && enteredCurContrEnd()) {
            showElement(stillServingNotice);
            setNavButtonLabel('Finish');
            return;
        } else if ( isStillServing() ) {
            navNextButton.classList.add('hidden');
        }
        hideElement(stillServingNotice);
        setNavButtonLabel('Next');
    }

    function endedContract() {
        return getRadioValue('EndedContract') == 1;
    }

    function toggleContractInfo() {
        if (getRadioValue('EndedContract') == null 
            || (!endedContract() && getRadioValue('StillServingContract') == null)
        ) {
            hideElement(contactInfoGroup);
            return;
        }
        if (endedContract() || !isStillServing()) {
            showElement(contactInfoGroup);
            return;
        }
        hideElement(contactInfoGroup);
    }

    function enteredCurContrEnd() {
        
        var month = document.getElementById('CurContrEndMonth');
        var year = document.getElementById('CurContrEndYear');
        console.log(month.value);
        console.log(year.value);
        console.log((month.value != '') && (year.value != ''));
        return (month.value != '') && (year.value != '');
    }

    function getDiffDays(d1, d2) {
        var days = (d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24);
        return days;
    }

    function hasRevisedEndOfContract() {
        return revisedEndYearInput.value && revisedEndMonthInput.value;
    }

    function outOfWindow() {
        var contractEndDate = new Date(revisedEndYearInput.value, (revisedEndMonthInput.value - 1)),
            today = new Date();

        if (isNaN(parseInt(revisedEndYearInput.value)) || getDiffDays(today, contractEndDate) > -365) {
            return true;
        }
        return false;
    }

    function toggleOutOfWindowNotice() {
        if (!hasRevisedEndOfContract()) {
            return;
        }

        if (outOfWindow()) {
            showElement(outOfWindowNotice);
            hideElement(restOfIntroElement);
            setNavButtonLabel('Finish');
            return;
        }

        hideElement(outOfWindowNotice);
        showElement(restOfIntroElement);
        setNavButtonLabel('Next');
    }

    addGroupEventListener('EndedContract', 'change', function () {
        toggleBlockFromGroup('EndedContract', 'contract-info-group');
    });
    addGroupEventListener('EndedContract', 'change', toggleStillServingNotice);
    addGroupEventListener('StillServingContract', 'change', toggleStillServingNotice);
    addGroupEventListener('StillServingContract', 'change', toggleContractInfo);
    addGroupEventListener('CurContrEndMonth', 'change', toggleStillServingNotice);
    addGroupEventListener('CurContrEndYear', 'change', toggleStillServingNotice);

    revisedEndMonthInput.addEventListener('change', toggleOutOfWindowNotice);
    revisedEndYearInput.addEventListener('change', toggleOutOfWindowNotice);

    toggleBlockFromGroup('EndedContract', 'contract-info-group');
    toggleStillServingNotice()
    toggleOutOfWindowNotice();
    toggleNavButtonText();
    toggleContractInfo();

    $('#nav-next').click(function(){
        var text = $("#nav-next").text();
        $("#nav-next").hide();
        $("#nav-next").after("<div class='btn btn-primary'>" +text+"</div>");
        // hiding the real next button and creating a fake one due to how the survey package needs the button there and not disabled in order to work
    });
});
